import { createContext } from "react";

const AgentContext = createContext();

export default AgentContext;
